<template>
  <div>
    <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <b-row>
        <b-col
          lg="6"
          md="6"
          sm="12"
        >
          <div style="font-size: 20px;">
            <b-img
              class="mr-1"
              height="30"
              src="@/assets/images/icons/chartg.svg"
            />
            <span>กราฟแสดงจำนวนเหตุการณ์ภายใน 1 เดือน</span>
            <!-- <em>word wrap</em> -->
          </div>
        </b-col>
        <b-col
          lg="6"
          md="6"
          sm="12"
          class="d-flex align-items-center justify-content-end"
        >
          <label style="padding-right:14px; font-size: 15px">ประเภท</label>
          <b-form-group style="padding-right:14px">
            <v-select
              v-model="searchChart.type_analytic"
              :reduce="(option) => option.key"
              :options="[
                { label: 'รถหยุด', key: 'carStop' },
                { label: 'รถย้อนศร', key: 'wrongWay' },
              ]"
              @input="getChart()"
            />
          </b-form-group>
          <label style="padding-right:14px; font-size: 15px">เดือน</label>
          <b-form-group style="padding-right:14px">
            <flat-pickr
              v-model="searchChart.dateFrom"
              :config="monthSelect"
              style="width: 80px;"
              class="form-control"
              @input="getChart()"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <div class="mt-2">
            <app-echar-line
              :option-data="option"
            />
          </div>
        </b-col>

      </b-row>

    </b-card>

  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BImg, BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-extraneous-dependencies
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import AppEcharLine from '@/views/vms/detail/garaphLineDB/AppEchartLineDB.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
  components: {
    BCard,
    BImg,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    flatPickr,
    AppEcharLine,
  },
  data() {
    return {
      searchChart: {
        department: '',
        type_analytic: 'carStop',
        dateFrom: '',
      },
      monthSelect: {
        plugins: [
          // eslint-disable-next-line new-cap
          new monthSelectPlugin({
            shorthand: true, // defaults to false
            dateFormat: 'm-Y', // defaults to "F Y"
            altFormat: 'F Y', // defaults to "F Y"
            theme: 'dark', // defaults to "light"
          }),
        ],
      },
      option: {
        xAxisData: [],
        series: [
          {
            name: 'Total',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFFFFF' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.5)' },
              ]),
            },
            color: '#FFFFFF',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.setToday()
    this.searchChart.department = this.userData.department
    this.getChart()
    this.interval = setInterval(() => {
      this.getChart()
    }, 300000)
  },
  methods: {
    getChart() {
      if (this.searchChart.type_analytic === 'carStop') {
        this.option.series[0].name = 'รถหยุด'
      } else {
        this.option.series[0].name = 'รถย้อนศร'
      }
      this.option.xAxisData.splice(0)
      this.option.series[0].data.splice(0)
      axios
        .post('/graphAnalytic30Day', this.searchChart)
        .then(response => {
          this.xAxisDataWind = []
          this.xAxisDataWind = response.data
          this.xAxisDataWind.forEach(value => {
            this.option.xAxisData.push(value.DATE_TIME)
            this.option.series[0].data.push(value.Total)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const year = p.getFullYear()
      console.log(year)
      this.searchChart.dateFrom = `${month}-${year}`
    // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
